import React, { useEffect, useState } from "react";
import {
  PDFViewer,
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  BlobProvider,
} from "@react-pdf/renderer";
import { Button, Col, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom"; // Import useNavigate for navigation
import pfdImage from "../../Assets/Logo/pdflogo-g.png";
import pfdImageText from "../../Assets/Logo/pdflogo-text-g.png";
import API from "../../services/api";
import { usePic } from "../../context/PicProvider";
import { toast } from "react-toastify";
import { exportExcel } from "../../utils/ExportExcel";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    flexWrap: "wrap",
    padding: 5,
  },
  column: {
    width: "25%",
    padding: 5,
  },
  cell: {
    border: 1,
    borderColor: "#000",
    borderRadius: 8,
    paddingTop: 8,
    paddingBottom: 10,
    display: "flex",
    alignItems: "center",
  },
  textStyle: {
    padding: 5,
    fontSize: 6,
  },
  image: {
    width: 120,
    height: 112,
    borderRadius: 5,
  },
  imagePrent: {},
  barHeading: {
    color: "black",
    fontWeight: "bold",
    fontSize: "17px",
  },
  imageChildPdf: {
    width: 80,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "0px",
  },
  imagePdfText: {
    width: 120,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "0px",
  },
});

const ViewKitPDF = () => {
  const { setIsLoading } = usePic();
  const { id } = useParams();
  const [kitData, setKitData] = useState([]);
  const [loading, setLoading] = useState(true);
console.log("test")
  const getKitData = async () => {
    setIsLoading(true);
    try {
      const res = await API.post(`admin/fetch_pdf_data/${id}`);
      const result = res.data;
      console.log("API Response:", result);
      if (result?.status === 200) {
        setKitData(result?.data);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error("Failed to fetch Kit management data:", error);
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    getKitData();
  }, []);

  const handleExportExcel = () => {
    const worksheetData = kitData.map((item) => ({
      QR_link: item.qr_link,
    }));
    exportExcel(worksheetData);
  };

  const handleDownloadPdf = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "kitbatchPDF.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Function to create a page with 4x4 data
  const getPages = (data) => {
    const pages = [];
    const itemsPerPage = 16; // 4x4 grid = 16 items per page
    const totalPages = Math.ceil(data.length / itemsPerPage);

    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
      const pageData = data.slice(
        pageIndex * itemsPerPage,
        (pageIndex + 1) * itemsPerPage
      );
      pages.push(
        <Page size="A4" style={styles.page} key={pageIndex}>
          {pageData.map((user, index) => (
            <View style={styles.column} key={index}>
              <View style={styles.cell}>
                <Image src={pfdImageText} style={styles.imagePdfText} />
                <Image src={user.qr_code_url} style={styles.image} />
                <View style={styles.imagePrent}>
                  <Image
                    src={pfdImage}
                    alt="pdfimage"
                    style={styles.imageChildPdf}
                  />
                </View>
              </View>
              <Text style={styles.textStyle}>{user.qr_code}</Text>
            </View>
          ))}
        </Page>
      );
    }

    return pages;
  };

  const MyDocument = (
    <Document title="kitbatchPDF">{kitData && getPages(kitData)}</Document>
  );

  return (
    <Stack className="justify-content-center align-items-center full-dynamic-height mx-4">
      {loading ? null : kitData.length === 0 && !loading ? (
        <Col
          className="flex-grow-0 bg-white shadow p-3 d-flex  flex-column gap-2 rounded-4 w-100"
          style={{ maxWidth: "900px" }}
        >
          <h5 className="m-0 text-center">No Pdf Found Yet</h5>
        </Col>
      ) : (
        <Col
          className="flex-grow-0 bg-white shadow p-3 d-flex  flex-column gap-2 rounded-4 w-100"
          style={{ maxWidth: "900px" }}
        >
          {/* PDF Viewer */}
          <BlobProvider document={MyDocument}>
            {({ blob, url, loading, error }) => {
              console.log("Blob URL:", url);
              if (loading) {
                return (
                  <Stack
                    style={{
                      height: "600px",
                    }}
                    className="align-items-center justify-content-center text-center w-100"
                  >
                    <p>Preparing PDF, please wait...</p>
                    <div className="loader"></div>
                  </Stack>
                );
              }

              if (error) {
                return <p>Error generating PDF: {error.message}</p>;
              }

              return (
                <>
                  <PDFViewer
                    src={url}
                    width="100%"
                    style={{ height: "calc(100dvh - 160px)" }}
                  />
                  <hr className="m-2" />
                  <Col className="d-flex justify-content-end gap-3 flex-wrap">
                    <Button onClick={() => handleDownloadPdf(url)}>
                      Download as PDF
                    </Button>
                    <Button onClick={handleExportExcel}>
                      Download as Excel
                    </Button>
                  </Col>
                </>
              );
            }}
          </BlobProvider>
        </Col>
      )}
    </Stack>
  );
};

export default ViewKitPDF;
